class BindingUtil {
  constructor(editor) {
    this.editor = editor;
  }
  editor;
  static props;
  static migrations;
  /**
   * The type of the binding util, which should match the binding's type.
   *
   * @public
   */
  static type;
}
export {
  BindingUtil
};
//# sourceMappingURL=BindingUtil.mjs.map
